var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.819 394.18H102.583V416H219.819V394.18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.888 305.684H102.583V327.504H262.888V305.684Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.95 217.205H102.583V239.025H330.95V217.205Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.95 128.726H223.312V150.546H330.95V128.726Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.765 465.44C392.765 476.668 383.63 485.82 372.39 485.82H61.141C49.9 485.82 40.765 476.669 40.765 465.44V175.998H165.32C179.093 175.998 190.296 164.787 190.296 151.01V26.181H372.389C383.629 26.181 392.764 35.316 392.764 46.545V193.615L418.949 167.435V46.544C418.949 20.885 398.06 0 372.389 0H183.532C169.958 0 156.955 5.379 147.368 14.968L29.565 132.78C19.967 142.371 14.584 155.386 14.584 168.948V465.44C14.584 491.115 35.474 512 61.141 512H372.39C398.061 512 418.95 491.115 418.95 465.44V340.23L392.765 366.411V465.44ZM167.021 32.345V137.001C167.021 148.32 162.611 152.722 151.295 152.722H46.639L167.021 32.345Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M493.792 206.746L466.031 178.985C461.203 174.153 453.371 174.153 448.539 178.985L430.541 196.983L475.799 242.236L493.792 224.239C498.624 219.406 498.624 211.578 493.792 206.746Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.897 364.632L247.469 425.316L308.15 409.884L262.897 364.632Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.152 355.372L317.409 400.626L467.57 250.469L422.313 205.207L272.152 355.372ZM439.801 243.27L308.973 374.098L298.688 363.804L429.515 232.976L439.801 243.27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/Signature.e4546783460d1232e601f59ec6b3f230.svg";
export { ForwardRef as ReactComponent };